import { call, put, select, takeEvery } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getDocumentsTypeRestricted from '../../services/document/getDocumentsTypeRestricted'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchDocumentsTypeRestrictedCombo () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    let combo = yield call(getDocumentsTypeRestricted, auth.token)
    yield put(fetchCombosSuccess({ documentsTypeRestrictedCombo: combo }))
  } catch (error) {
    const sessionHandler = function * () {
    }
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler, sessionHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchDocumentsTypeRestrictedCombo () {
  yield takeEvery(combosActionTypes.FETCH_DOCUMENTS_TYPE_RESTRICTED_COMBO, fetchDocumentsTypeRestrictedCombo)
}
